// 中转站
import { post, get, deletefn, putfun } from './http.js'
export default {
  // 中转站文件类型
  async file_type (params) {
    return await get ('/mime-type-list',params)
  },
  // 中转站文件类型
  async file_list (params) {
    return await get ('/resource',params)
  },
  // 中转站分类列表
  async file_category (params) {
    return await get ('/resource-category',params)
  },
  // 中转站分类添加
  async file_category_add (params) {
    return await post ('/resource-category',params)
  },
  // 中转站分类编辑
  async file_category_edit (params) {
    return await putfun (`/resource-category/${params.id}`,params)
  },
  // 中转站删除分类
  async file_category_delete (params) {
    return await deletefn (`/resource-category/${params}`)
  },
  // 文件移动
  async file_remove (params) {
    return await putfun (`/resource-move`,params)
  },
}



// WEBPACK FOOTER //
// ./src/request/transferStation.js